const FETCH_ORDER = 'FETCH_ORDER';
const FETCH_ORDER_FULFILLED = 'FETCH_ORDER_FULFILLED';
const FETCH_ORDER_REJECTED = 'FETCH_ORDER_REJECTED';
const CLEAR_ACCOUNT_ORDER = 'CLEAR_ACCOUNT_ORDER';
const CLEAR_ORDER_MODIFICATIONS = 'CLEAR_ORDER_MODIFICATIONS';
const CANCEL_ORDER_ITEMS = 'CANCEL_ORDER_ITEMS';
const CANCEL_ORDER_ITEMS_FULFILLED = 'CANCEL_ORDER_ITEMS_FULFILLED';
const CANCEL_ORDER_ITEMS_REJECTED = 'CANCEL_ORDER_ITEMS_REJECTED';
const CANCEL_ORDER = 'CANCEL_ORDER';
const CANCEL_ORDER_FULFILLED = 'CANCEL_ORDER_FULFILLED';
const CANCEL_ORDER_REJECTED = 'CANCEL_ORDER_REJECTED';
const SPLIT_ORDER = 'SPLIT_ORDER';
const SPLIT_ORDER_FULFILLED = 'SPLIT_ORDER_FULFILLED';
const SPLIT_ORDER_REJECTED = 'SPLIT_ORDER_REJECTED';

export {
  CANCEL_ORDER,
  CANCEL_ORDER_FULFILLED,
  CANCEL_ORDER_ITEMS,
  CANCEL_ORDER_ITEMS_FULFILLED,
  CANCEL_ORDER_ITEMS_REJECTED,
  CANCEL_ORDER_REJECTED,
  CLEAR_ACCOUNT_ORDER,
  CLEAR_ORDER_MODIFICATIONS,
  FETCH_ORDER,
  FETCH_ORDER_FULFILLED,
  FETCH_ORDER_REJECTED,
  SPLIT_ORDER,
  SPLIT_ORDER_FULFILLED,
  SPLIT_ORDER_REJECTED,
};
